import { ComponentType as p } from "../../registries/types/propTypes.js";
const g = (n) => {
  var s;
  const o = Array.isArray(n == null ? void 0 : n.standard_banner_no_cta) ? n == null ? void 0 : n.standard_banner_no_cta[0] : n == null ? void 0 : n.standard_banner_no_cta, c = (s = o == null ? void 0 : o.images) == null ? void 0 : s.map((r) => {
    var t, _;
    return {
      redirectionInfo: {
        target: r.link.target,
        url: r.link.url
      },
      imageList: (_ = (t = r == null ? void 0 : r.image) == null ? void 0 : t.images) == null ? void 0 : _.map((e) => ({
        url: e.image.url,
        altText: e.alt_text,
        viewport: e.viewport
      }))
    };
  });
  return {
    componentType: p.standard_banner_no_cta,
    images: c
  };
};
export {
  g as default
};
//# sourceMappingURL=standard-banner-no-cta-transformer.js.map
